import React, { useEffect, useMemo, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import axios from 'axios';
import './free-trial-login.css';
import {
  Col, Container, Row, Spinner,
} from 'react-bootstrap';
import FreeTrialMarketingPanel from './FreeTrialMarketingPanel';
import FreeTrialLoginForm from './FreeTrialLoginForm';
import envConfig from '../../../envConfig';
import decodeBase64Param from '../../../utility/decodeBase64Param';

const FREE_TRIAL_TOKEN_TYPE_ID = 1;

const FreeTrialLoginPage = () => {
  const history = useHistory();
  const { sid, em } = useParams();

  const subscriptionId = useMemo(() => decodeBase64Param(sid), [sid]);
  const emailFromUrl = useMemo(() => decodeBase64Param(em), [em]);

  const [isEligible, setIsEligible] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const redirectToGateway = () => {
      window.location.replace('/gateway');
    };

    const checkEligibility = async () => {
      try {
        const response = await axios.get(`${envConfig.apiUrl}/api/v1/token/has-valid-by-subscription`, {
          params: {
            subscriptionId,
            typeId: FREE_TRIAL_TOKEN_TYPE_ID,
          },
        });

        if (cancelled) return;

        const payload = response.data || {};
        const hasValidToken = payload.success && payload.data && payload.data.hasValidToken;

        if (hasValidToken) {
          setIsEligible(true);
        } else {
          redirectToGateway();
        }
      } catch (err) {
        if (!cancelled) {
          redirectToGateway();
        }
      }
    };

    if (!subscriptionId || !emailFromUrl) {
      redirectToGateway();
      return undefined;
    }

    checkEligibility().then();
    return () => { cancelled = true; };
  }, [subscriptionId, emailFromUrl, history]);

  if (isEligible === null) {
    return (
      <Container className="text-center py-5">
        <Spinner animation="border" role="status">
          <span className="sr-only">Loading…</span>
        </Spinner>
      </Container>
    );
  }

  return (
    <Container fluid className="py-4">
      <Row className="align-items-start">
        <Col xs={12} md={6} xl={6} className="free-trial-divider pb-4 pb-md-0 mb-4 mb-md-0 pr-md-4">
          <FreeTrialMarketingPanel />
        </Col>
        <Col xs={12} md={6} xl={4} className="pl-md-4 mt-4 mx-xl-auto">
          <FreeTrialLoginForm
            subscriptionId={subscriptionId}
            initialEmail={emailFromUrl}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default FreeTrialLoginPage;
